<!-- 模板 -->
<template>
  <div class="footer-page">
    <div class="footer">
      <footer>
        <div class="wrap">
          <a
            href="https://bszs.conac.cn/sitename?method=show&id=1899713022545F43E053012819ACF0E6"
            target="_blank"
          >
            <img src="../assets/dzicon.png" alt="" class="dzicon" />
          </a>
          <a href="javascsript:;">
            <img src="../assets/govsiteimg.png" alt="" class="govicon" />
          </a>

          <div class="info-box">
            <nav>
              <ul class="nav-list">
                <li>
                  <a
                    href="https://rsj.beijing.gov.cn/yw/201912/t20191225_1457400.html"
                    target="_blank"
                    title="关于我们"
                    >关于我们</a
                  >
                </li>
                <div class="line">-</div>
                <li>
                  <a
                    href="https://rsj.beijing.gov.cn/yw/201912/t20191225_1457453.html"
                    target="_blank"
                    title="法律声明"
                    >法律声明</a
                  >
                </li>
                <div class="line">-</div>
                <li>
                  <a
                    href="https://rsj.beijing.gov.cn/yw/map/"
                    target="_blank"
                    title="网站地图"
                    >网站地图</a
                  >
                </li>
                <div class="line">-</div>
                <li>
                  <a
                    href="https://rsj.beijing.gov.cn/hudong/xinxiang/rsj/sindex/xx-rsj.html"
                    target="_blank"
                    >建议征集</a
                  >
                </li>
              </ul>
            </nav>
            <p>政策咨询服务热线12333</p>
            <p class="flex">
              主办：北京市人力资源和社会保障局<span
                >承办：北京市人力资源和社会保障局大数据中心</span
              >
            </p>
          </div>
          <div class="code-list">
            <div class="code-item">
              <img src="../assets/weibocode.png" alt="" />
              <p>官方微博</p>
            </div>
            <div class="code-item">
              <img src="../assets/wechatcode.png" alt="" />
              <p>微信公众号</p>
            </div>
          </div>
        </div>
      </footer>
      <div class="footer-bottom">
        <div class="wrap">
          <span>政府网站标识码:1100000062</span>
          <span
            ><a
              href="https://beian.miit.gov.cn/#/Integrated/index"
              target="_blank"
              >京公网安备:110102000777</a
            ></span
          >
          <span
            ><a
              href="https://beian.miit.gov.cn/#/Integrated/index"
              target="_blank"
              >ICP备案序号:京ICP备05056884号</a
            ></span
          >
        </div>
      </div>
    </div>
    <!-- <iframe
      width="100%"
      src="https://fuwu.rsj.beijing.gov.cn/frame/footer_new.html"
      frameborder="0"
      style="height: 200px; margin-bottom: -50px"
      data-v-2ee45c6a=""
    ></iframe> -->
  </div>
</template>
<script>
// import request from '../utils/request.js'
export default {
  name: "Footer",
  data() {
    return {
      links: [
        { text: "关于我们", path: "/" },
        { text: "法律声明", path: "/about" },
        { text: "网站地图", path: "/upload" },
        { text: "建议征集", path: "/feedback" },
      ],
    };
  },
  props: [],
  components: {},
  computed: {},
  filters: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="less">
// @import url(); 引入公共css类
footer {
  width: 100%;
  height: 160px;
  background-color: #bd1a2d;
  .wrap {
    padding-left: 14px;
    display: flex;
    align-items: center;
    height: 100%;
    color: #fff;
    img {
      display: block;
    }
    .dzicon {
      width: 52px;
      margin-right: 49px;
    }
    .govicon {
      width: 110px;
      margin-right: 15px;
    }
    .info-box {
      background-color: #a01818;
      padding: 15px;
      width: 630px;
      font-size: 14px;
      height: 128px;
      p {
        &:not(:last-child) {
          margin-bottom: 18px;
        }
      }
      .nav-list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 18px;
        li {
          a {
            color: #fff;
          }
        }
        .line {
          margin: 0 10px;
        }
      }
    }
    .code-list {
      margin-left: auto;
      display: flex;
      align-items: center;
      .code-item {
        height: 128px;
        background-color: #a01818;
        padding-top: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 12px;
        width: 130px;
        &:not(:last-child) {
          margin-right: 15px;
        }
        img {
          width: 80px;
          height: 80px;
          object-fit: fill;
          margin-bottom: 5px;
        }
      }
    }
  }
}
.flex {
  display: flex;
  align-content: center;
  gap: 20px;
}
.footer-bottom {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #dabb85;
  text-align: center;
  font-size: 14px;
  min-width: 1200px;
  span {
    padding-right: 20px;
  }
}

@media screen and (max-width: 1024px) {
  footer {
    height: auto;
    padding: 16px 0;

    .wrap {
      flex-wrap: wrap;
      align-items: flex-start;
      height: auto;
      padding: 0 12px;
      gap: 12px;

      .dzicon {
        width: 44px;
        margin-right: 16px;
      }

      .govicon {
        width: 90px;
        margin-right: 0;
      }

      .info-box {
        order: 3;
        width: 100%;
        height: auto;
        padding: 12px;
        font-size: 13px;

        .nav-list {
          margin-bottom: 12px;

          .line {
            margin: 0 6px;
          }
        }

        p {
          line-height: 1.6;

          &:not(:last-child) {
            margin-bottom: 10px;
          }
        }
      }

      .code-list {
        order: 4;
        width: 100%;
        margin-left: 0;
        justify-content: center;
        gap: 12px;

        .code-item {
          flex: 1;
          max-width: 130px;
          height: auto;
          padding: 12px 8px 10px;

          img {
            width: 64px;
            height: 64px;
          }
        }
      }
    }
  }

  .flex {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;

    span {
      display: block;
    }
  }

  .footer-bottom {
    min-width: 0;
    height: auto;
    line-height: 1.6;
    padding: 10px 12px;
    font-size: 12px;

    .wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
    }

    span {
      display: block;
      padding-right: 0;
    }
  }
}

@media screen and (max-width: 480px) {
  footer {
    .wrap {
      .info-box {
        font-size: 12px;

        .nav-list {
          justify-content: center;
        }
      }

      .code-list .code-item {
        max-width: 110px;

        img {
          width: 56px;
          height: 56px;
        }
      }
    }
  }

  .footer-bottom {
    font-size: 11px;
  }
}
</style>
